export const MAX_TICKETS_PER_PURCHASE = 10;
export const LOCAL_STORAGE_SESSION_KEY = 'checkoutSessionId';
export const LOCAL_STORAGE_EXPIRY_KEY = 'checkoutSessionExpiry';